import { NgModule } from '@angular/core';
import { IconNameToDefinitionPipe } from "./icon-name-to-definition.pipe";
import { CommonModule } from "@angular/common";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";


@NgModule({
    imports: [CommonModule, FontAwesomeModule],
    exports: [IconNameToDefinitionPipe],
    declarations: [IconNameToDefinitionPipe],
})
export class IconNameToDefinitionModule {
}
